import NamedDto from 'modules/base/dto/NamedDto';
import AnnotationEditDto from './AnnotationEditDto';

export class ProjectEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {AnnotationEditDto[]} */
		this.annotations = [];
	}

	/**
	 * @typedef {Object} _ProjectEditDtoProps
	 * @property {AnnotationEditDto[]} annotations
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ProjectEditDtoProps} ProjectEditDtoProps
	 */
	/**
	 *
	 * @param {ProjectEditDtoProps} props
	 * @returns {ProjectEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.annotations = Array.isArray(props.annotations)
			? props.annotations.map(annotation => new AnnotationEditDto().setup(annotation))
			: [];
		return this;
	}
}

export default ProjectEditDto;
